import { Button } from "@chef/components";

type CartStepProgressButtonProps = {
  onClick?: () => void;
  isLoading: boolean;
  children: React.ReactNode;
};

export const CartStepProgressButton = ({
  onClick,
  isLoading,
  children,
}: CartStepProgressButtonProps) => {
  return (
    <Button loading={isLoading} primary onClick={onClick} full>
      {children}
    </Button>
  );
};
